import React from 'react';
import { USER_RELEASES, USER_VISIBLE_RELEASE_COUNT } from '../constants/userReleaseNotes';
import { APP_VERSION } from '../constants/appVersion';

// Teacher-facing "What's New": only the most recent releases are shown here.
// The full history lives in constants/userReleaseNotes.js and is rendered for
// admins in Global Admin → Logs & Audit → Release Notes.
// v3.78.2: the header names the RUNNING version and "(Current)" is tagged only
// on the entry whose version equals it — the newest listed entry is often an
// older teacher-facing release (admin-only releases add no entry here).
function ReleaseNotesModal({ isOpen, onClose, currentVersion = APP_VERSION }) {
  if (!isOpen) return null;

  const releases = USER_RELEASES.slice(0, USER_VISIBLE_RELEASE_COUNT);

  return (
    <div className="modal-overlay" style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 10000
    }}>
      <div className="modal-content" style={{
        background: 'white', padding: '30px', borderRadius: '12px',
        width: '90%', maxWidth: '600px', maxHeight: '80vh',
        display: 'flex', flexDirection: 'column',
        boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div>
            <h2 style={{ margin: 0, color: '#334155' }}>What's New</h2>
            <div style={{ fontSize: '0.85em', color: '#64748b', marginTop: 2 }}>{`You're on v${currentVersion}`}</div>
          </div>
          <button
            onClick={onClose}
            style={{ background: 'transparent', border: 'none', fontSize: '1.5em', cursor: 'pointer', color: '#94a3b8' }}
            title="Close"
          >
            &times;
          </button>
        </div>

        <div style={{ overflowY: 'auto', flex: 1, paddingRight: '10px' }}>
          {releases.map((release, index) => (
            <div key={index} style={{ marginBottom: '25px', paddingBottom: index < releases.length - 1 ? '15px' : '0', borderBottom: index < releases.length - 1 ? '1px solid #e2e8f0' : 'none' }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', marginBottom: '10px' }}>
                <h3 style={{ margin: 0, color: '#0f172a' }}>{`v${release.version}${release.version === currentVersion ? ' (Current)' : ''}`}</h3>
                <span style={{ fontSize: '0.85em', color: '#64748b' }}>{release.date}</span>
              </div>
              <ul style={{ margin: 0, paddingLeft: '20px', color: '#334155', lineHeight: '1.6' }}>
                {release.changes.map((change, cIndex) => (
                  <li key={cIndex} style={{ marginBottom: '5px' }}>{change}</li>
                ))}
              </ul>
            </div>
          ))}
          <div style={{ fontSize: '0.85em', color: '#94a3b8', textAlign: 'center', marginTop: '5px' }}>
            Showing the {USER_VISIBLE_RELEASE_COUNT} most recent updates.
          </div>
        </div>

        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button
            onClick={onClose}
            style={{ padding: '10px 30px', background: '#3b82f6', border: 'none', borderRadius: '6px', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}
          >
            Got it, thanks!
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReleaseNotesModal;
